<div class="modal-header">
  <h4 class="modal-title">New Version Available</h4>
  <button
    *ngIf="!this.forceUpdate"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="dismiss()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<ng-container *ngIf="!!this.forceUpdate">
  <div class="modal-body">
    <p>
      An update is required to continue. The application will now refresh to the latest version.
    </p>
  </div>
</ng-container>
<ng-container *ngIf="!this.forceUpdate">
  <div *ngIf="this.currentUser" class="modal-body">
    <p>A new version of the application is available and needs to be updated.</p>
    <p>
      Please refresh or download the latest version to continue. Any unsaved changes may be lost.
    </p>
  </div>
  <div *ngIf="!this.currentUser" class="modal-body">
    <p>A new version is available. Updating now may restart your progress.</p>
  </div>
</ng-container>

<div class="modal-footer">
  <button
    *ngIf="this.currentUser && !this.forceUpdate"
    type="button"
    class="btn btn-secondary"
    (click)="snooze()"
  >
    Snooze
  </button>
  <button
    *ngIf="!this.currentUser && !this.forceUpdate"
    type="button"
    class="btn btn-secondary"
    (click)="dismiss()"
  >
    Dismiss
  </button>
  <button type="button" class="btn btn-primary" (click)="refreshPage()">Refresh Now</button>
</div>
